<template>
  <v-card class="padding_top shadow-none order-table-card">
    <div
      class="d-flex-row mb-8 align-items-center npage-header"
      style="padding:0 2rem"
    >
      <div style="flex:0.7" class="d-flex-row">
        <h3 class="mb-0 h3-text">{{ $t("newUi.OrderManagement.OMOrders") }}</h3>
        <v-icon
          style="margin-left:1rem;"
          aria-hidden="false"
          @click="getInitialData()"
          color="success"
        >
          mdi-cached
        </v-icon>
      </div>
      <div class="search-field">
        <v-text-field
          style="flex:0.4"
          v-model="search"
          append-icon="mdi-magnify"
          v-bind:placeholder="this.placeHolderText()"
          single-line
          hide-details
        ></v-text-field>
      </div>
    </div>

    <div class="table-custom-wrapper" style="padding:0 2rem">
      <v-data-table
        :headers="dataHeaders"
        :loading="tableDataloading"
        :loading-text="this.TextLoading()"
        :items="filteredItems"
        :search="search"
        :single-expand="singleExpand"
        :expanded.sync="expanded"
        @item-expanded="read"
        item-key="Order_id"
        show-expand
        class="elevation-1 order-tags"
        fixed-header
        :footer-props="{
          'items-per-page-text': this.productsPerPageText(),
          'items-per-page-options': [5, 10, 15, 30, 50, -1],
          'items-per-page-all-text': this.AllLabelFooter(),
        }"
      >
        <template v-slot:[`item.Order_id`]="{ item }">
          {{ item.Order_id }}
          <span v-if="!item.isRead" class="unread"> </span>
        </template>

        <template v-slot:item.total_amount="{ item }">
          <span>{{ item.priceWithCurrency }}</span>
        </template>

        <template v-slot:[`item.order_status`]="{ item }">
          <span
            v-bind:style="{ color: getColor(item.order_status) }"
            style="font-weight:bold;"
          >
            {{ getStatus(item.order_status) }}
            <!-- {{ item.order_status }} -->
          </span>
          <div
            class="status-badge"
            v-bind:style="{ background: getColor(item.order_status) }"
          ></div>
        </template>

        <template v-slot:expanded-item="{ headers, item }">
          <td
            :colspan="headers.length"
            style="padding:20px;background:rgb(245 245 245)"
          >
            <table class="inner-list">
              <tr>
                <th>{{ $t("newUi.OrderManagement.OMSrNo") }}</th>
                <th style="max-width: 400px;min-width: 350px;">
                  {{ $t("newUi.OrderManagement.OMItem") }}
                </th>
                <th>{{ $t("newUi.OrderManagement.OMquantity") }}</th>
                <th>{{ $t("newUi.OrderManagement.OMSubTotal") }}</th>
              </tr>
              <tr v-for="(itemDetail, index) in item.Items" :key="index">
                <td>{{ index + 1 }}</td>
                <td style="max-width: 400px;min-width: 350px;">
                  {{ itemDetail.name }} - {{ itemDetail.description }}
                </td>
                <td>{{ itemDetail.qty }}</td>
                <td>{{ item.symbol }} {{ itemDetail.sub_total }}</td>
              </tr>
            </table>

            <div class="align-right" v-if="item.order_status == 'Pending'">
              <v-btn
                color="#E9505B"
                elevation="2"
                v-on:click="confirmation('reject', item)"
                style="border-radius:15px;"
              >
                {{ $t("newUi.OrderManagement.OMRejectOrder") }}</v-btn
              >
              <v-btn
                color="#128C7E"
                elevation="2"
                v-on:click="confirmation('approve', item)"
                style="margin-left:2rem;border-radius:15px"
                >{{ $t("newUi.OrderManagement.OMConfirmOrder") }}</v-btn
              >
              <span
                style="margin-left:2rem;font-size:16px;font-weight:600;position: relative;top: 8px;"
                >{{ $t("newUi.OrderManagement.OMTotal") }} {{ item.symbol }}
                {{ item.total_amount }}</span
              >
            </div>
            <div class="align-right" v-if="item.order_status == 'In-Progress'">
              <v-btn
                color="#E9505B"
                elevation="2"
                v-on:click="confirmation('cancel', item)"
                style="border-radius:15px"
                >{{ $t("newUi.OrderManagement.OMCancelOrder") }}</v-btn
              >
              <v-btn
                color="#128C7E"
                elevation="2"
                v-on:click="confirmation('complete', item)"
                style="margin-left:2rem;border-radius:15px"
                >{{ $t("newUi.OrderManagement.OMCompleteOrder") }}</v-btn
              >
              <span
                style="margin-left:2rem;font-size:16px;font-weight:600;position: relative;top: 8px;"
                >{{ $t("newUi.OrderManagement.OMTotal") }} {{ item.symbol }}
                {{ item.total_amount }}</span
              >
            </div>
            <div class="align-right" v-if="item.order_status == 'Completed'">
              <v-btn
                color="#E9505B"
                elevation="2"
                v-on:click="confirmation('return', item)"
                style="border-radius:15px"
                >{{ $t("newUi.OrderManagement.OMReturnOrder") }}</v-btn
              >
              <span
                style="margin-left:2rem;font-size:16px;font-weight:600;position: relative;top: 8px;"
                >{{ $t("newUi.OrderManagement.OMTotal") }} {{ item.symbol }}
                {{ item.total_amount }}</span
              >
            </div>
            <div
              class="align-right"
              v-if="
                item.order_status == 'Cancelled' ||
                  item.order_status == 'Returned'
              "
            >
              <span
                style="margin-left:2rem;font-size:16px;font-weight:600;position: relative;top: 8px;"
                >{{ $t("newUi.OrderManagement.OMTotal") }} {{ item.symbol }}
                {{ item.total_amount }}</span
              >
            </div>
          </td>
        </template>

        <template v-slot:no-data>
          <div class="no-orders">
            <p>{{ $t("newUi.OrderManagement.OMNoOrder") }}</p>
          </div>
        </template>
      </v-data-table>

      <template>
        <v-dialog v-model="dialog" height="50vh" width="500">
          <v-card
            v-if="modalData.type"
            style=" height: 350px;padding: 30px; text-align: center;"
          >
            <v-btn @click="dialog = false" class="close-btn" :ripple="false"
              ><img src="../assets/close.svg" />
            </v-btn>
            <div
              v-html="modalData.title"
              class="text-h5  lighten-2"
              style="justify-content: center;color: #8AB26D;font-weight: bold;"
            ></div>

            <v-card-text style="text-align:center; margin-top: -17px;">
              <div
                v-html="modalData.message"
                style="width:400px;margin-top:2rem;font-size:16px;line-height:1.6"
              ></div>
            </v-card-text>

            <div class="flex-center">
              <div class="info-box d-flex-row" style="justify-content:center;">
                <div
                  style="margin-top: 18px;  margin-right: 15px;  color: #8AB26D;"
                >
                  <v-icon small style="color: #8AB26D;"
                    >fas fa-info-circle</v-icon
                  >
                </div>
                <div style="text-align: justify;">
                  {{ $t("newUi.OrderManagement.OMinfo1") }}
                </div>
              </div>
            </div>

            <v-card-actions style="justify-content:center;">
              <v-spacer></v-spacer>
              <v-btn color="#E9505B" elevation="2" @click="dialog = false">{{
                $t("newUi.OrderManagement.OMCancel")
              }}</v-btn>
              <v-btn
                color="#128C7E"
                elevation="2"
                :loading="loading && indexClicked === 'confirm'"
                style="margin-left:2rem;"
                v-on:click="updateStatus('confirm')"
              >
                {{ modalData.title }}</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
    </div>
  </v-card>
</template>

<script>
import axios from "axios";
import { getJWTToken } from "../services/firebase";
import i18n from "../i18n";
import moment from "moment";

export default {
  data() {
    return {
      expanded: [],
      getTotal: (item) => item.Items.reduce((sum, li) => sum + +li.price, 0),
      singleExpand: true,
      tableDataloading: false,
      modalData: {},
      status: {
        Pending: 1,
        "In-Progress": 2,
        Completed: 3,
        Cancelled: 4,
        Returned: 5,
        Rejected: 6,
      },
      info: [],
      loadingMsg: "Loading... Please wait",
      dialog: false,
      search: "",
      indexClicked: undefined,
      loading: false,
    };
  },

  methods: {
    placeHolderText: function() {
      // return "Search by OrderID or Customers"
      return i18n.t("newUi.OrderManagement.OMsearchBy");
    },
    productsPerPageText: function() {
      return i18n.t("newUi.OrderManagement.OMPagination");
    },
    AllLabelFooter: function() {
      return i18n.t("newUi.OrderManagement.OMAllLabel");
    },
    TextLoading: function() {
      return i18n.t("newUi.OrderManagement.OMLoading");
    },
    translateIdStatus: function(message, orderId, status) {
      if (status != "notAvailable") {
        let answer = message.replace("$$Order_id$$", "*#" + orderId + "*");
        answer = answer.replace("$$status$$", status);
        return answer;
      } else {
        let answer = message.replace("$$Order_id$$", "*#" + orderId + "*");
        return answer;
      }
    },
    confirmation: function(type, item) {
      const { Order_id } = item;
      this.dialog = true;
      let message, title;
      switch (type) {
        case "approve":
          title = i18n.t("newUi.OrderManagement.OMConfirmOrder");
          message = i18n.t("newUi.OrderManagement.OMConfirmMessage");
          break;
        case "reject":
          title = i18n.t("newUi.OrderManagement.OMRejectOrder");
          message = i18n.t("newUi.OrderManagement.OMRejectMessage");
          break;
        case "return":
          title = i18n.t("newUi.OrderManagement.OMReturnOrder");
          message = i18n.t("newUi.OrderManagement.OMReturnMessage");
          break;
        case "cancel":
          title = i18n.t("newUi.OrderManagement.OMCancelOrder");
          message = i18n.t("newUi.OrderManagement.OMCancelMessage");
          break;
        case "complete":
          title = i18n.t("newUi.OrderManagement.OMCompleteOrder");
          message = i18n.t("newUi.OrderManagement.OMCompleteMessage");
          break;
      }
      // item.phone_number.substring(item.phone_number.lastIndexOf("-") + 1),
      this.modalData = {
        title,
        message,
        type,
        item,
        phone: item.phone_number.replace("-", ""),
        url: `${process.env.VUE_APP_API_ENDPOINT}fsdata/v1/orderStatus/Order/${Order_id}`,
      };
    },
    updateStatus: function(confirm) {
      // console.log(confirm)
      let self = this;
      this.loading = true;

      const { url, type } = this.modalData;
      this.indexClicked = confirm;
      let headers = {
        "Content-Type": "application/json",
        Authorization: getJWTToken(),
      };
      const status = {
        approve: "In-Progress",
        reject: "Cancelled",
        return: "Returned",
        cancel: "Cancelled",
        complete: "Completed",
      };
      axios
        .patch(url, { order_status: status[type] }, { headers: headers })
        .then(function() {
          self.getInitialData();
          self.loading = false;
          self.dialog = false;
          self.createWhatsappMessage(type);
        })
        .catch(function(response) {
          //handle error
          // debugger
          console.log(response);
        });
    },
    read: function({ item }) {
      if (item.isRead) return;
      let headers = {
        "Content-Type": "application/json",
        Authorization: getJWTToken(),
      };
      let self = this;
      axios
        .patch(
          `${process.env.VUE_APP_API_ENDPOINT}fsdata/v1/orderStatus/updateIsRead/${item.Order_id}`,
          { isRead: true },
          { headers: headers }
        )
        .then(function() {
          self.getInitialData();
        })
        .catch(function(response) {
          console.log(response);
        });
    },
    getInitialData: function() {
      let self = this;
      this.tableDataloading = true;
      axios
        .get(`${process.env.VUE_APP_API_ENDPOINT}fsdata/v1/getOrders`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: getJWTToken(),
          },
        })
        .then((response) => {
          // console.log("json response ====", response);
          response.data.response.map((obj) => {
            (obj.created = moment(obj.created).format("YYYY-MM-DD HH:mm:ss")),
              (obj.paymentMethod = i18n.t("newUi.OrderManagement.OMPayLater"));
          });
          response.data.response.sort(
            (a, b) => self.status[a.order_status] - self.status[b.order_status]
          );
          self.tableDataloading = false;

          response.data.response.map((obj) => {
            if (obj.country_code) {
              obj.phone_number = `${obj.country_code}-${obj.phone_number}`;
              if (obj.symbol == "R$") {
                obj.priceWithCurrency = `${
                  obj.symbol
                } ${obj.total_amount.toString().replace(".", ",")}`;
                obj.Items.map((each_item) => {
                  var subtotal = each_item.sub_total.toString();
                  each_item.sub_total = subtotal.replace(".", ",");
                });
                obj.total_amount = obj.total_amount
                  .toString()
                  .replace(".", ",");
              } else
                obj.priceWithCurrency = `${obj.symbol} ${obj.total_amount}`;
            }
          });
          this.info = response.data.response;
        });
    },
    createWhatsappMessage: function(status) {
      let phoneno = this.modalData.phone;
      const status_type = {
        // approve: `Confirmed`,
        // reject: `Rejected`,
        // return: `Returned`,
        // cancel: `Cancelled`,
        // complete: `Completed`,
        approve: i18n.t("newUi.OrderManagement.OMconfirm2"),
        reject: i18n.t("newUi.OrderManagement.OMreject2"),
        return: i18n.t("newUi.OrderManagement.OMreturn2"),
        cancel: i18n.t("newUi.OrderManagement.OMcancel2"),
        complete: i18n.t("newUi.OrderManagement.OMcomplete2"),
      };
      let suffixMsg = i18n.t("newUi.OrderManagement.OMSuffixMsg");
      // "If you have any queries related to your order you can chat with the Merchant here.";
      // let message = `Your order *#${this.modalData.item.Order_id}* has been ${status_type[status]}! \nYour order details are: \n*Quantity* X *Item* X *Price* \n`;
      let message = this.translateIdStatus(
        i18n.t("newUi.OrderManagement.OMmsg1"),
        this.modalData.item.Order_id,
        status_type[status]
      );
      for (let i = 0; i < this.modalData.item.Items.length; i++) {
        message =
          message +
          `${this.modalData.item.Items[i].qty} X ${this.modalData.item.Items[i].name} X ${this.modalData.item.Items[i].sub_total}\n`;
      }
      message = message + "*" + i18n.t("newUi.OrderManagement.OMhead3") + " *";
      message =
        message +
        `${this.modalData.item.symbol} ${this.modalData.item.total_amount} \n ${suffixMsg}`;

      if (status == "reject") {
        // message = `Your Order *#${this.modalData.item.Order_id}* has been ${status_type[status]}! \n ${suffixMsg}`;
        message =
          this.translateIdStatus(
            i18n.t("newUi.OrderManagement.OMmsg2"),
            this.modalData.item.Order_id,
            status_type[status]
          ) + `\n ${suffixMsg}`;
      } else if (status == "complete") {
        // message = `Your Order *#${this.modalData.item.Order_id}* has been delivered successfully and is now Completed! \n ${suffixMsg} `;
        message =
          this.translateIdStatus(
            i18n.t("newUi.OrderManagement.OMmsg3"),
            this.modalData.item.Order_id,
            "notAvailable"
          ) + `\n ${suffixMsg}`;
      } else if (status == "cancel") {
        // message = `YourOrder *#${this.modalData.item.Order_id}* has been cancelled! \n ${suffixMsg}`;
        message =
          this.translateIdStatus(
            i18n.t("newUi.OrderManagement.OMmsg4"),
            this.modalData.item.Order_id,
            "notAvailable"
          ) + `\n ${suffixMsg}`;
      } else if (status == "return") {
        // message = `Your request for Return for Order *#${this.modalData.item.Order_id}* has been processed successfully! \n ${suffixMsg}`;
        message =
          this.translateIdStatus(
            i18n.t("newUi.OrderManagement.OMmsg5"),
            this.modalData.item.Order_id,
            "notAvailable"
          ) + `\n ${suffixMsg}`;
      }
      let url = `https://wa.me/${encodeURI(phoneno)}/?text=${encodeURIComponent(
        message
      )}`;
      window.open(url, "_blank");
    },
    getColor(status) {
      if (status == "Cancelled") return "#999999";
      else if (status == "In-Progress") return "#FFCE00";
      else if (status == "Returned") return "#31333E";
      else if (status == "Completed") return "#8AB26D";
      else return "#E9505B";
    },
    getStatus(status) {
      if (status == "Cancelled")
        return i18n.t("newUi.OrderManagement.OMstatus2");
      else if (status == "In-Progress")
        return i18n.t("newUi.OrderManagement.OMstatus1");
      else if (status == "Returned")
        return i18n.t("newUi.OrderManagement.OMstatus3");
      else if (status == "Completed")
        return i18n.t("newUi.OrderManagement.OMstatus4");
      else return i18n.t("newUi.OrderManagement.OMstatus7");
    },
  },
  mounted() {
    this.getInitialData();
  },
  watch: {
    locale() {
      this.getInitialData();
    },
  },
  computed: {
    locale() {
      return this.$store.state.locale;
    },
    dataHeaders() {
      return [
        {
          text: i18n.t("newUi.OrderManagement.OMhead1"),
          align: "start",
          value: "Order_id",
        },
        {
          text: i18n.t("newUi.OrderManagement.OMhead2"),
          value: "phone_number",
        },
        {
          text: i18n.t("newUi.OrderManagement.OMhead3"),
          value: "total_amount",
        },
        {
          text: i18n.t("newUi.OrderManagement.OMhead4"),
          value: "paymentMethod",
        },
        { text: i18n.t("newUi.OrderManagement.OMhead5"), value: "created" },
        {
          text: i18n.t("newUi.OrderManagement.OMhead6"),
          value: "order_status",
        },
        { text: "", value: "data-table-expand" },
      ];
    },
    filteredItems() {
      return this.info.filter((i) => {
        return (
          !this.search ||
          i.Order_id.indexOf(this.search) >= 0 ||
          i.phone_number.toString().indexOf(this.search) >= 0
        );
      });
    },
  },
};
</script>

<style>
.confirm {
  background: #128c7e;
}
.cancel {
  background: #e9505b;
}

.padding_top {
  padding: 40px;
}

table {
  border-collapse: collapse;
  width: 100%;
}

.align-right {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 100%;
  margin-top: 2rem;
  padding-right: 4rem;
}

th {
  font-size: 16px !important;
}

.text-center {
  text-align: center;
}

.d-flex-row {
  display: flex;
  flex-direction: row;
}

thead {
  background: #31333e !important;
}

thead th {
  color: #fff !important;
}
.mt2 {
  margin-top: 2rem;
}

.v-btn__content {
  color: #fff;
}
/* .v-sheet{
      height: 220px;
} */
.theme--light.v-data-table
  .v-data-table-header
  th.sortable
  .v-data-table-header__icon {
  color: #fff !important;
}

.status-badge {
  width: 7px;
  height: 48px;
  position: absolute;
  right: 40px;
  margin-top: -35px;
}

.info-box {
  font-size: 12px;
  color: #999999;
  width: 350px;
  background: #fff5c5 0% 0% no-repeat padding-box;
  border-radius: 5px;
  padding: 8px;
  margin-bottom: 15px;
}
.flex-center {
  display: flex;
  justify-content: center;
}
.unread {
  background: #e9505b;
  width: 7px;
  position: absolute;
  height: 7px;
  border-radius: 50%;
  margin: 6px -55px;
}
.search-field {
  width: 100%;
  margin-left: auto;
  max-width: 345px;
  background: #f4f4f4 0% 0% no-repeat padding-box;
}
.search-field .v-input {
  padding: 0;
  margin: 0;
}
.search-field .v-input .v-input__slot:after,
.search-field .v-input .v-input__slot:before {
  display: none;
}
.search-field .v-input input {
  height: 40px;
  max-height: initial;
  padding: 13px 15px 13px 20px;
  letter-spacing: 0px;
  color: #666666;
  font-size: 12px;
  line-height: 24px;
}
.search-field .v-input .v-input__append-inner {
  margin: 0;
  padding: 0;
  height: 40px;
  display: flex;
  align-items: center;
  padding-right: 10px;
}
.search-field .v-input .v-input__append-inner i {
  color: #8ab26d;
}
.h3-text {
  letter-spacing: 0px;
  color: #31333e;
  opacity: 1;
  font-size: 24px;
  font-weight: bold;
  font-family: "helvetica-neue-bold";
}
.table-custom-wrapper {
  border: 0 !important;
  box-shadow: none !important;
}
.table-custom-wrapper .v-data-table {
  border: 0 !important;
  box-shadow: none !important;
}
.table-custom-wrapper table {
  border-spacing: 0 10px !important;
  border-collapse: unset;
}
.table-custom-wrapper table thead {
  background: transparent !important;
  position: relative;
  z-index: 1;
}
.table-custom-wrapper table thead th {
  background: #31333e !important;
  height: 45px !important;
  font-size: 12px !important;
  padding: 10px 20px !important;
}
.table-custom-wrapper table thead th:first-child {
  border-radius: 5px 0 0 5px;
}
.table-custom-wrapper table thead th:last-child {
  border-radius: 0 5px 5px 0;
}
.table-custom-wrapper table thead th i {
  vertical-align: middle;
  margin: -6px 0 0 4px;
}
.table-custom-wrapper table tbody td {
  background: #f4f4f4 0% 0% no-repeat padding-box;
  border: 0 !important;
  padding: 8px 20px !important;
  letter-spacing: 0px;
  color: #666666;
  font-size: 12px !important;
  height: auto !important;
}
.table-custom-wrapper table tbody tr {
  position: relative;
}
.table-custom-wrapper table tbody tr .status-badge {
  right: 0;
  height: 40px;
  top: 0;
  margin: 0;
}
.v-data-table .v-data-footer button {
  background: #f4f4f4;
}
.v-data-table .v-data-footer button span {
  color: rgba(0, 0, 0, 0.54);
}
.v-dialog .close-btn {
  padding: 0 !important;
  box-shadow: none !important;
  background: transparent !important;
  min-width: auto !important;
  height: auto !important;
  position: absolute;
  right: 20px;
  top: 20px;
}
.v-dialog .close-btn:before {
  display: none;
}
.v-dialog .close-btn img {
  width: 16px;
  height: 16px;
}
.v-data-table .v-data-table__wrapper {
  max-height: calc(100vh - 234px);
  overflow-y: auto;
  overflow-x: hidden;
  min-height: calc(100vh - 234px);
}
.table-custom-wrapper .v-data-table__expanded__content {
  top: -10px;
  box-shadow: none !important;
}
.table-custom-wrapper .v-data-table__expanded__content > td {
  padding: 0 20px 16px 28px !important;
  background: rgb(244 244 244 / 50%) !important;
}
.table-custom-wrapper tr.v-data-table__progress {
  top: -25px;
  position: relative;
}
.table-custom-wrapper tr.v-data-table__empty-wrapper {
  position: relative;
  top: -35px;
  z-index: 0;
}
.order-table-card {
  padding: 20px;
}
.no-orders {
  height: calc(100vh - 320px);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: -10px -20px;
  background: #fff;
}
.theme--light.v-data-table
  .v-data-table-header
  th.sortable
  .v-data-table-header__icon {
  font-size: 0 !important;
  margin: 0;
  width: 18px;
  height: 15px;
  background: url("../assets/sorting.svg");
  display: inline-block;
  opacity: 1;
  background-position: center;
  background-size: 18px 15px;
  vertical-align: middle;
  margin-top: -2px;
  margin-left: 2px;
  background-repeat: no-repeat;
}
.v-select__slot .v-input__append-inner {
  position: relative;
  padding-left: 0 !important;
}
.v-select__slot .v-input__append-inner .v-input__icon {
  min-width: 18px !important;
  width: 18px;
}
</style>
